module.exports = __webpack_public_path__ + "static/media/2DGACM1.83030341.jpg";